/* eslint-disable @typescript-eslint/no-explicit-any */
import { buildNestedStructure } from 'app/components/Core/LineItem/helpers'
import dayjs from 'dayjs'
import { chain } from 'lodash'

import { normalizeCategorySegment } from './CategorySegment'
import { convertIsoToString, convertStringToIso } from './utilities'

export function normalizeLineItem(lineItem: any): ILineItem {
  if (lineItem) {
    return {
      ...lineItem,
      category_segment_name: lineItem.categorySegment?.name,
      start_date: convertIsoToString(lineItem.start_date),
      return_date: convertIsoToString(lineItem.return_date),
      sub_items: lineItem.subItems
        ?.filter((subItem: ISubItem) => subItem.lineItemType === 'product')
        ?.map(normalizeLineItem),
      subItems: lineItem.subItems
        ?.filter((subItem: ISubItem) => subItem.lineItemType === 'product')
        ?.map(normalizeLineItem)
    }
  }
}

export function normalizeProductSubItems(lineItem: ILineItem): ILineItem {
  if (lineItem) {
    return {
      ...lineItem,
      startDate: convertIsoToString(lineItem.startDate),
      start_date: convertIsoToString(lineItem.startDate),
      returnDate: convertIsoToString(lineItem.returnDate),
      return_date: convertIsoToString(lineItem.returnDate),
      categorySegment: normalizeCategorySegment(lineItem.categorySegment, lineItem.attributeValues),
      subItems: lineItem.subItems
        ?.filter((subItem) => subItem.lineItemType === 'product')
        ?.map(normalizeProductSubItems)
    }
  }
}

export function MachineGroupNormalizer(products: ILineItem[] = []): Array<IMachineGroup> {
  const productWithFilteredSubItems = buildNestedStructure(products, { flatList: false }).sort(
    (a, b) => dayjs(a.start_date).valueOf() - dayjs(b.return_date).valueOf()
  )

  return chain(productWithFilteredSubItems)
    .groupBy('returnDate')
    .map((value: ILineItem[], key: string) => ({
      date: key,
      lineItems: value.map((lineItem: ILineItem) => ({
        ...lineItem,
        start_date: convertIsoToString(lineItem.start_date),
        return_date: convertIsoToString(lineItem.return_date)
      }))
    }))
    .value()
}

export function BaseDateNormalizer(payload: any) {
  return {
    ...payload,
    returnDate: convertIsoToString(payload.returnDate),
    startDate: convertIsoToString(payload.startDate)
  }
}

export function ChangeRequestNormalizer(payload: any) {
  return {
    ...payload,
    returnDate: convertStringToIso(payload.returnDate),
    startDate: convertStringToIso(payload.startDate)
  }
}

export function normalizeNestedStructure(lineItems: ILineItem[] = [], flatList = false) {
  return buildNestedStructure(lineItems, { flatList }).map(normalizeLineItem)
}
